<template>
  <div v-if="canVerb('reports', 'index') && hasConfiguredOptions && !noData">
    <div align="right">
      <b-dropdown right size="sm" toggle-class="btn--smaller btn--transparent">
        <template #button-content>
          <span>
            <base-icon name="download" width="20" height="20" />
            <span class="export-btn-label">Esporta</span>
          </span>
        </template>
        <b-dropdown-group id="dropdown-group-1" v-if="hasCsvReports">
          <b-dropdown-header id="dropdown-header-csv">
            Esporta in CSV
          </b-dropdown-header>
          <span
            v-for="(option, index) in options.filter((e) =>
              e.formats.includes('csv'),
            )"
            :key="index"
          >
            <b-dropdown-item-button
              v-if="hasType('csv', option) && canReport('csv', option)"
            >
              <b-dropdown-item
                v-if="hasType('csv', option) && canReport('csv', option)"
                @click="handle('csv', option)"
                >{{ getLabel("csv", option) }}</b-dropdown-item
              >
            </b-dropdown-item-button>
          </span>
        </b-dropdown-group>
        <b-dropdown-group id="dropdown-group-2" v-if="hasPdfReports">
          <b-dropdown-header id="dropdown-header-pdf">
            Esporta in PDF
          </b-dropdown-header>
          <span
            v-for="(option, index) in options.filter((e) =>
              e.formats.includes('pdf'),
            )"
            :key="index"
          >
            <b-dropdown-item-button
              v-if="hasType('pdf', option) && canReport('pdf', option)"
            >
              <b-dropdown-item
                v-if="hasType('pdf', option) && canReport('pdf', option)"
                @click="handle('pdf', option)"
                >{{ getLabel("pdf", option) }}</b-dropdown-item
              >
            </b-dropdown-item-button>
          </span>
        </b-dropdown-group>
        <b-dropdown-text v-if="!hasCsvReports && !hasPdfReports">
          Nessun report disponibile
        </b-dropdown-text>
      </b-dropdown>
    </div>
    <submit-report-modal
      :code="realCode(optCod)"
      @save-report="saveReport"
      :beFormCreate="beFormCreate"
      :beRulesCreate="beRulesCreate"
      :allowedFormatOptions="allwdOpts"
    />
    <select-option-modal
      :opts="[
        { text: 'Si', value: 'Y' },
        { text: 'No', value: 'N' },
      ]"
      title="Stampa percentuali applicate?"
      @select="onSelectOption"
    />
  </div>
</template>

<script>
import BaseIcon from "@/components/BaseIcon";
import ExportsMixin from "@/mixins/ExportsMixin";
import ReportsMixin from "@/mixins/ReportsMixin";
import StorageGetterMixin from "@/mixins/StorageGetterMixin";
import SubmitReportModal from "@/components/modals/submitReportModal";
import SelectOptionModal from "@/components/modals/selectOption";
import { canVerb } from "@/utils/permissions";
import { mapGetters } from "vuex";

export default {
  mixins: [ExportsMixin, ReportsMixin, StorageGetterMixin],
  data() {
    return {
      // UNUSEFUL variable expomons: EXPO* reports permissions DO NOT depend on mapped index permission, but as usual on pivot.allowed flags!!!
      // however, this is the mapping between report-code and model, if need to discover the index where an EXPO* report would preferably be placed...
      // expomons: {
      //   EXPOADBO: "address_books",
      //   EXPOAGBO: "agency_books",
      //   EXPOAGCO: "agency_contacts",
      //   EXPOAGSE: "agency_setups",
      //   EXPOATTR: "attributes",
      //   EXPOBOEN: "book_entries",
      //   EXPOBREA: "breakdowns",
      //   EXPOBRST: "broker_statements",
      //   EXPOBROK: "brokers",
      //   EXPOCLAI: "claims",
      //   EXPOCLPA: "claim_parties",
      //   EXPOCOTR: "consolidated_treasuries",
      //   EXPOCORR: "correspondences",
      //   EXPODOCU: "documents",
      //   EXPOGERE: "generated_reports",
      //   EXPOINAC: "insurer_accounting",
      //   EXPOINAN: "insurance_ancillaries",
      //   EXPOINPA: "insurance_payments",
      //   EXPOINPO: "insurance_policies",
      //   EXPOINRI: "insurance_risks",
      //   EXPOINSU: "insurers",
      //   EXPOINAR: "insurer_participants",
      //   EXPOMACO: "mandate_codes",
      //   EXPOPARE: "payment_references",
      //   EXPOREGI: "registries",
      //   EXPOREGR: "registry_groups",
      //   EXPOSECT: "sectors", -> ESTCONCO
      //   EXPOTASK: "tasks",
      //   EXPOTREA: "treasuries",
      //   EXPOUNPA: "unsolved_payments",
      //   EXPOUSER: "users",
      //   EXPOVAAC: "various_accounting", -> LISTVAR
      // },
      exportFormat: null, // used for custom reports (eg: RENPROVUNOFFICIALIZED) that open custom modal with custom extras
      extraOption: null,
      optionCode: null,
      allowed: [], // allowed report formats for the chosen report (for compatibility with generated reports, since here we already know the format of the chosen report)
    };
  },
  created() {
    /* */
    const path = "auth/";
    const resources = [];
    if (canVerb("reports", "index") && !this.hasLoadedResource("reports")) {
      resources.push(
        this.$store
          .dispatch(`${path}reports`)
          .then(() => {})
          .catch((error) => {
            let errMsg = this.$getErrorMessage(error);
            this.$showSnackbar({ preset: "error", text: errMsg });
          }),
      );
    }
    if (resources.length) {
      this.getResources(resources)
        .then(() => {})
        .catch((error) => {
          console.log("One or more promises crashed... :|");
          this.onFailure(error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    } else {
      this.isLoading = false;
    }
    /* */
  },
  props: {
    exportUrl: String, // value is defined by onSearch methods
    repository: String, // value is defined at index
    resource: String, // value is defined at index
    tableRef: null, // value is defined at index
    filter: {
      // valore definito nelle index
      type: Object,
      default() {
        return {};
      },
    },
    noData: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Array,
      default() {
        return [
          {
            code: null,
            label: null,
            formats: [],
            // utilizzare extra SOLO casi particolari, es: 'RENPROVUNOFFICIALIZED'
            // quando queryString deve inviare dati specifici... (dipende dal report)
            // extra: {
            //   produttori: smids,
            //   salesman_id: smid,
            // },
            extra: {},
          },
        ];
      },
    },
  },
  components: {
    BaseIcon,
    SubmitReportModal,
    SelectOptionModal,
  },
  methods: {
    saveReport(code, form) {
      switch (code) {
        case "TOTASOSP":
        case "REGIFOCA":
        case "LISTITINCA":
        case "EXPOINPA":
          this.onExport(this.exportFormat, code, form.request_input)
            .then((reportObj) => {
              reportObj.label = this.getToastLabel(reportObj.code);
              console.log("reportObj", reportObj);
              this.$root.$emit("toastReport", reportObj);
            })
            .catch((error) => {
              let errMsg = this.$getErrorMessage(error);
              this.$showSnackbar({
                preset: "error",
                text: `${errMsg}`,
              });
            });
          this.$bvModal.hide(code);
          break;
        case "FOGQUAD":
          this.onExportFogQuad(this.exportFormat, code, form.request_input)
            .then((reportObj) => {
              reportObj.label = this.getToastLabel(reportObj.code);
              console.log("reportObj", reportObj);
              this.$root.$emit("toastReport", reportObj);
            })
            .catch((error) => {
              let errMsg = this.$getErrorMessage(error);
              this.$showSnackbar({
                preset: "error",
                text: `${errMsg}`,
              });
            });
          this.$bvModal.hide(code);
          break;
        case "EXPOLITI":
          this.onExportExpoliti(this.exportFormat, code, form.request_input)
            .then((reportObj) => {
              reportObj.label = this.getToastLabel(reportObj.code);
              console.log("reportObj", reportObj);
              this.$root.$emit("toastReport", reportObj);
            })
            .catch((error) => {
              let errMsg = this.$getErrorMessage(error);
              this.$showSnackbar({
                preset: "error",
                text: `${errMsg}`,
              });
            });
          this.$bvModal.hide(code);
          break;
        case "REPOINCLI":
          this.onExportRepoincli(this.exportFormat, code, form.request_input)
            .then((reportObj) => {
              reportObj.label = this.getToastLabel(reportObj.code);
              console.log("reportObj", reportObj);
              this.$root.$emit("toastReport", reportObj);
            })
            .catch((error) => {
              let errMsg = this.$getErrorMessage(error);
              this.$showSnackbar({
                preset: "error",
                text: `${errMsg}`,
              });
            });
          this.$bvModal.hide(code);
          break;
        default:
          this.save(code, form);
      }
    },
    canVerb,
    getLabel(type, option) {
      if (option.label) {
        return `${option.code} - ${option.label}`;
      }
      let rc = this.realCode(option.code);
      let r = this.getReport()(rc);
      // return `Esporta ${type}: ${r?.title}`;
      return `${r.code} - ${r.title}`;
    },
    getToastLabel(code) {
      let ret = this.getReport()(code);
      return `${ret.code} - ${ret.title}`;
    },
    canReport(type, option) {
      let c = option.code;
      if (!c) {
        return false;
      }
      // report RENPROVUNOFFICIALIZED è "fittizio" -> segue i permessi di RENPROV

      let rc = this.realCode(c);
      // console.log("RC: ", rc);
      // WRONG: EXPO* reports permissions depend on mapped index (expomons), not pivot.allowed flags??? NO!
      // if (rc.startsWith("EXPO")) {
      //   return this.canVerb(this.expomons[rc], "index");
      // }
      let r = this.getReport()(rc);
      if (!r || !r.users || !r?.users?.length || !r?.users[0]?.pivot) {
        try {
          console.debug(
            `canReport: NO -> report: ${JSON.stringify(
              Object.keys(r || {})
                .filter((e) => ["id", "code", "title", "users"].includes(e))
                .reduce((obj, key) => {
                  return Object.assign(obj, {
                    [key]: r[key],
                  });
                }, {}),
              null,
              2,
            )}`,
          );
        } catch (error) {
          console.error(error);
        }
        return false;
      }
      return r.users[0]?.pivot.allowed?.includes(type);
    },
    realCode(code) {
      // return the base code of a variant report
      // NOTE: keep this up-to-date when new variant reports are introduced
      let c;
      switch (code) {
        case "RENPROVUNOFFICIALIZED":
          c = "RENPROV";
          break;
        default:
          c = code;
          break;
      }
      return c;
    },
    handle(type, option) {
      // based on report type and option's infos, trigger the correct method of ExportsMixin/ReportsMixin
      // NOTE: keep this up-to-date when new reports are introduced
      let c = option.code;
      this.$set(this, "optionCode", c);
      this.$set(this, "exportFormat", type);
      this.$set(this, "extraOption", option.extra);
      /**
       * ci sono 2 modalità di esportazione (handler):
       * 1. ExportsMixin: onExport(format, reportCode = "EXPOMON", requestInput = {}, silent = false)
       * 2. ReortsMixin: saveReport(code, form)
       *
       * ESEMPIO
       * INCACOMP2 viene esportato in csv e pdf
       * @csv="onExport('csv')"
       * @pdf="openReportModal('INCACOMP2')"
       *
       */
      switch (type) {
        case "csv":
          switch (c) {
            case "RENPROVUNOFFICIALIZED":
            case "TOTASOSP":
            case "REGIFOCA":
            case "EXPOLITI":
            case "EXPOINPA":
            case "FOGQUAD":
              this.$nextTick(() => {
                this.openReportModal(c);
              });
              break;
            case "COASSES":
              this.$nextTick(() => {
                this.openReportModal(c);
              });
              break;
            case "LISPOL":
              this.$nextTick(() => {
                this.openReportModal(c);
              });
              break;
            case "LISTIT":
              this.$nextTick(() => {
                this.openReportModal(c);
              });
              break;
            case "FOCALETACC":
              this.$nextTick(() => {
                this.openReportModal(c);
              });
              break;
            case "LISTITINCA":
              this.$nextTick(() => {
                this.openReportModal(c);
              });
              break;
            case "INCAGIO":
              this.onExportFogQuad(type, c)
                .then((reportObj) => {
                  reportObj.label = this.getToastLabel(reportObj.code);
                  console.log("reportObj", reportObj);
                  this.$root.$emit("toastReport", reportObj);
                })
                .catch((error) => {
                  let errMsg = this.$getErrorMessage(error);
                  this.$showSnackbar({
                    preset: "error",
                    text: `${errMsg}`,
                  });
                });
              break;
            case "EXPODAGE":
              this.onExportDage(type, c)
                .then((reportObj) => {
                  reportObj.label = this.getToastLabel(reportObj.code);
                  console.log("reportObj", reportObj);
                  this.$root.$emit("toastReport", reportObj);
                })
                .catch((error) => {
                  let errMsg = this.$getErrorMessage(error);
                  this.$showSnackbar({
                    preset: "error",
                    text: `${errMsg}`,
                  });
                });
              break;
            case "LOGCOM":
              this.onExportLisacomunicaLogs(type, c)
                .then((reportObj) => {
                  reportObj.label = this.getToastLabel(reportObj.code);
                  this.$root.$emit("toastReport", reportObj);
                })
                .catch((error) => {
                  let errMsg = this.$getErrorMessage(error);
                  this.$showSnackbar({
                    preset: "error",
                    text: `${errMsg}`,
                  });
                });
              break;
            default:
              this.onExport(type, c)
                .then((reportObj) => {
                  reportObj.label = this.getToastLabel(reportObj.code);
                  console.log("reportObj", reportObj);
                  this.$root.$emit("toastReport", reportObj);
                })
                .catch((error) => {
                  let errMsg = this.$getErrorMessage(error);
                  this.$showSnackbar({
                    preset: "error",
                    text: `${errMsg}`,
                  });
                });
              break;
          }
          break;
        case "pdf":
          switch (c) {
            case "RENPROVUNOFFICIALIZED":
            case "RENCOLLAB":
            case "FOGQUAD":
            case "EXPOINPA":
            case "REPOINCLI":
              this.$nextTick(() => {
                this.openReportModal(c);
              });
              break;
            case "FOCACOL":
            case "LISTSOSP":
            case "LISACOM":
            case "EXPOBOEN":
            case "EXPOINAN":
            case "EXPOAGE":
            case "EXPOPVCLI":
            case "EXPOPECLI":
            case "EXPOTICLI":
            case "EXPOATCLI":
            case "EXPOINCLI":
            case "EXPOTIPOL":
            case "EXPOATPOL":
            case "EXPOSINCLI":
            case "EXPOINPOL":
            case "EXPOSINPOL":
            case "COASSOP":
            case "COASSINC":
            case "SINPRECLI":
            case "EXPOINPO":
            case "EXCOFOCA":
            case "EXPOREGI":
            case "EXPOCLAI":
            case "ESTCONAG":
            case "TOTAFOCA":
            case "ESTCONCO":
            case "EXPOPRSPRD":
            case "LISTVAR":
            case "LISTABB":
            case "CONREGCOL":
            case "EXPOREGR":
            case "RUBRIGRU":
            case "EXPOAGCO":
            case "EXPOUNPA":
            case "LISTACC":
            case "EXPOAGBO":
            case "RENCOMPROV":
            case "EXPOPARE":
            case "EXCOGISO":
            case "EXCOGIAC":
            case "EXCOGICO":
            case "EXCOGIMO":
            case "EXPOSEPA":
            case "REDESCACO":
            case "EXPOLISO":
              this.onExport(type, c)
                .then((reportObj) => {
                  reportObj.label = this.getToastLabel(reportObj.code);
                  console.log("reportObj", reportObj);
                  this.$root.$emit("toastReport", reportObj);
                })
                .catch((error) => {
                  let errMsg = this.$getErrorMessage(error);
                  this.$showSnackbar({
                    preset: "error",
                    text: `${errMsg}`,
                  });
                });
              break;
            case "EXPODAGE":
            case "EXPOSCAME":
              this.onExportDage(type, c)
                .then((reportObj) => {
                  reportObj.label = this.getToastLabel(reportObj.code);
                  console.log("reportObj", reportObj);
                  this.$root.$emit("toastReport", reportObj);
                })
                .catch((error) => {
                  let errMsg = this.$getErrorMessage(error);
                  this.$showSnackbar({
                    preset: "error",
                    text: `${errMsg}`,
                  });
                });
              break;
            case "INCAGIO":
              this.onExportFogQuad(type, c)
                .then((reportObj) => {
                  reportObj.label = this.getToastLabel(reportObj.code);
                  console.log("reportObj", reportObj);
                  this.$root.$emit("toastReport", reportObj);
                })
                .catch((error) => {
                  let errMsg = this.$getErrorMessage(error);
                  this.$showSnackbar({
                    preset: "error",
                    text: `${errMsg}`,
                  });
                });
              break;
            // case "TOTASOSP": // REVIEW: ??? nel .docx scrivono 'report applicato ai risultati di una precedente ricerca', MA IN PDF???
            //   this.onExport(type, c);
            //   break;
            default:
              this.$nextTick(() => {
                this.openReportModal(c);
              });
              break;
          }
          break;
        default:
          break;
      }
    },
    openReportModal(code) {
      switch (code) {
        case "RENPROVUNOFFICIALIZED":
          this.$bvModal.show("selectOption");
          break;
        case "RENCOLLAB":
        case "TOTASOSP":
        case "INCACOL":
        case "LISTITINCA":
        case "REPONUCL":
        case "FOGQUAD":
        case "EXPOINPA":
        case "REPOINCLI":
          // questi report richiedono beForm
          this.fetchForm(code)
            .then(() => {
              this.$bvModal.show(code);
            })
            .catch((error) => {
              let errMsg = this.$getErrorMessage(error);
              this.$showSnackbar({
                preset: "error",
                text: errMsg,
              });
            });
          break;
        default:
          this.$bvModal.show(code);
          break;
      }
    },
    onSelectOption(value) {
      switch (this.optCod) {
        case "RENPROVUNOFFICIALIZED":
          if (value != null) {
            let payload = this.xtrOpt;
            payload["show_percentages"] = value;
            this.onExport(this.exportFormat, this.optCod, payload)
              .then((reportObj) => {
                reportObj.label =
                  "RENPROV - RENDICONTO PROVVIGIONALE PRODUTTORI";
                console.log("reportObj", reportObj);
                this.$root.$emit("toastReport", reportObj);
              })
              .catch((error) => {
                let errMsg = this.$getErrorMessage(error);
                this.$showSnackbar({
                  preset: "error",
                  text: `${errMsg}`,
                });
              });
          }
          break;
        case "RENCOLLAB":
          if (value != null) {
            let payload = {};
            payload["show_percentages"] = value;
            this.onExport(this.exportFormat, this.optCod, payload)
              .then((reportObj) => {
                console.log("reportObj", reportObj);
                this.$root.$emit("toastReport", reportObj);
              })
              .catch((error) => {
                let errMsg = this.$getErrorMessage(error);
                this.$showSnackbar({
                  preset: "error",
                  text: `${errMsg}`,
                });
              });
          }
          break;
        case "TOTASOSP":
          this.onExport(this.exportFormat, this.optCod)
            .then((reportObj) => {
              console.log("reportObj", reportObj);
              this.$root.$emit("toastReport", reportObj);
            })
            .catch((error) => {
              let errMsg = this.$getErrorMessage(error);
              this.$showSnackbar({
                preset: "error",
                text: `${errMsg}`,
              });
            });
          break;
        default:
          break;
      }
    },
    fetchForm(code) {
      return this.fetchEditForm("report", code)
        .then(() => {
          this.$set(this, "beFormCreate", this.beForm["report"]);
          this.$set(this, "beRulesCreate", this.beRules["report"]);
          // ho già selezionato sia il report sia il format (exportFormat)
          // a differenza di generated-reports, dove la modale chiede all'utente di scegliere un formato,
          // qui il formato risulta già scelto, quindi lo imposto direttamente
          // sarà poi il report stesso a validarne il permesso
          // e soprattutto ad impostare form.format nel created hook, quando come adesso tra i formati ne arriva solo 1
          this.$set(
            this,
            "allowed",
            this.beForm["report"].format.options.filter(
              (e) => e.text === this.exportFormat,
            ),
          );
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({ preset: "error", text: errMsg });
        });
    },
    ...mapGetters("auth", {
      getReport: "report",
    }),
  },
  computed: {
    optCod() {
      return this.optionCode;
    },
    xtrOpt() {
      return this.extraOption;
    },
    allwdOpts() {
      return this.allowed;
    },
    hasOptions() {
      return this.options.length ? true : false;
    },
    hasConfiguredOptions() {
      // a real export option (not the default empty placeholder)
      return this.options.some((o) => o.code && o.formats && o.formats.length);
    },
    hasCsvReports() {
      return this.options.some(
        (o) => this.hasType("csv", o) && this.canReport("csv", o),
      );
    },
    hasPdfReports() {
      return this.options.some(
        (o) => this.hasType("pdf", o) && this.canReport("pdf", o),
      );
    },
    hasType() {
      return (type, option) => {
        return option.formats.includes(type);
      };
    },
    hasPermission() {
      return (option) => {
        if (!this.hasType("pdf", option) && !this.hasType("csv", option)) {
          return false;
        } else if (this.hasType("pdf", option) || this.hasType("csv", option)) {
          if (
            !this.canReport("pdf", option) &&
            !this.canReport("csv", option)
          ) {
            return false;
          }
        }
        return true;
      };
    },
    hasPermissions() {
      let ret = false;
      for (const option of this.options) {
        // if (!this.hasType("pdf", option) && !this.hasType("csv", option)) {
        //   ret &&= false;
        // } else if (this.hasType("pdf", option) || this.hasType("csv", option)) {
        //   if (
        //     !this.canReport("pdf", option) &&
        //     !this.canReport("csv", option)
        //   ) {
        //     ret &&= false;
        //   }
        // }
        ret ||= this.hasPermission(option);
      }
      return ret;
    },
    allReportCodes() {
      // return [
      //   'AGGRECLI',   'AGRENPROV', 'COMINCA',    'CONREGCOL',
      //   'EXPOADBO',   'EXPOAGBO',  'EXPOAGCO',   'EXPOAGSE',
      //   'EXPOATTR',   'EXPOBOEN',  'EXPOBREA',   'EXPOBROK',
      //   'EXPOBRST',   'EXPOCLAI',  'EXPOCLPA',   'EXPOCORR',
      //   'EXPOCOTR',   'EXPODOCU',  'EXPOGERE',   'EXPOINAC',
      //   'EXPOINAN',   'EXPOINAR',  'EXPOINPA',   'EXPOINPO',
      //   'EXPOINRI',   'EXPOINSU',  'EXPOMACO',   'EXPOMON',
      //   'EXPOPARE',   'EXPOREGI',  'EXPOREGR',   'EXPOSECT',
      //   'EXPOTASK',   'EXPOTREA',  'EXPOUNPA',   'EXPOUSER',
      //   'LISTVAR',   'FOCACOL',   'INCACLIGRU', 'INCACOL',
      //   'INCACOMP',   'INCACOMP2', 'INCAPAGA',   'INCAPROD',
      //   'INCARAM',    'INCARAMTI', 'LISPOL',     'LISTIT',
      //   'LISTITINCA', 'MONUPROD',  'POLCLIGRU',  'POLCLIREL',
      //   'PORTATTI',   'REGIFOCA',  'RENCOLLAB',  'RENCOMP',
      //   'RENCOMPROV', 'RENPROD',   'RENPROV',    'RUBRICLI',
      //   'RUBRIGRU',   'SCACLIGRU', 'STATSCONT',  'TITINCACLI',
      //   'TITULTIGI',  'TOTAFOCA',  'TOTASOSP',   'LISTABB',
      //   'EXPOSEPA'
      // ]
      return this.$store.state.auth.reports.map((e) => e.code).sort();
    },
  },
};
</script>
<style lang="scss" scoped>
:deep(.dropdown-item) {
  font-size: 0.75rem;
  padding: 0.25rem 0.75rem;
}

:deep(.dropdown-menu.show) {
  min-width: fit-content;
  margin-top: 6px;
  border: 2px solid var(--color-text);
  border-radius: 0.5rem;
}

:deep(.export-btn-label) {
  position: relative;
  top: 1px;
  font-size: var(--font-size-md);
  font-weight: 500;
  margin-left: 3px;
}

:deep(.dropdown-header) {
  font-size: 0.75rem;
  padding: 0.25rem 1.1rem;
  font-weight: 500;
  color: var(--color-text);
}
</style>
